<script setup lang="ts">
import type { PortableTextComponentProps } from '@portabletext/vue';
import Video from '@pkg/ui/components/base/Video.vue';
export interface VideoData {
  videoUrl: string,
  controls: boolean,
  autoplay: boolean,
}

const props = defineProps<PortableTextComponentProps<VideoData>>();

</script>

<template>
  <div>
    <Video :url="props.value.videoUrl" :controls="props.value.controls ?? true" :autoplay="props.value.autoplay ?? false"/>
  </div>
</template>

<style scoped>

</style>
